export type WeatherItemConfig = {
  statusSection?: boolean;
  removeIcon?: boolean;
};
